import React from "react";
import PageLayout from "../../components/PageLayout";
import OBHavingTroubleCard from "../onboarding/_components/OBHavingTroubleCard";
import "./styles/products.css";
import ProductsWrapper from "./components/ProductsWrapper";
function ProductsMain() {
  return (
    <PageLayout>
      <section className="d-flex flex-1xl-nowrap flex-column flex-wrap flex-xl-row align-items-start gap-3 product-listing-main-wrapper-section">
        <ProductsWrapper />
        {/* <OBHavingTroubleCard /> */}
      </section>
    </PageLayout>
  );
}

export default ProductsMain;
